export function switchCompanyToSleekSign(domain, companyId) {
  if (!domain) return;
  try {
    let iframe = document.getElementById("app_iframe");
    iframe.onload = () => {
      let win;
      try {
        win = iframe.contentWindow;
      } catch (e) {
        win = iframe.contentWindow;
      }
      let payload = {
        companyId,
        action: "SwitchCompany",
        isSleekPayload: true,
      };
      // save obj in subdomain localStorage
      win.postMessage(JSON.stringify({ key: "storage", method: "set", data: payload }), "*");
    };
    iframe.src = domain;
  } catch (error) {
    console.log("Something went wrong on initializing switchCompanyToSleekSign", error);
  }
}
